var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mi-clase-con-sombra pa-6"},[_c('h3',{staticClass:"mb-4",staticStyle:{"color":"#42352E"}},[_vm._t("title-panel")],2),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }